import { chakra, useMultiStyleConfig } from "@chakra-ui/react";
import { Control, useFormState } from "react-hook-form";
import { Checkmark } from "../../icons";
import type { TypeOf, ZodType } from "zod";

type CheckmarkProps<FormSchema extends ZodType> = {
	formKey: TypeOf<FormSchema>;
	control: Control<TypeOf<FormSchema>>;
	children: React.ReactNode;
};

export const CheckmarkWrapper = <FormSchema extends ZodType>({
	formKey,
	control,
	children,
}: CheckmarkProps<FormSchema>) => {
	const { touchedFields, errors } = useFormState({ control });
	const styles = useMultiStyleConfig("CheckmarkWrapper");

	return (
		<chakra.div __css={styles.wrapper}>
			{children}
			<chakra.div __css={styles.offset}>
				{touchedFields[formKey] && !errors[formKey] && (
					<Checkmark __css={styles.icon} />
				)}
			</chakra.div>
		</chakra.div>
	);
};

// 🔬 TBD: Please evaluate
